import SG_AREA from '../json/city.json'

const addressSelectObj = {
    getProvince() {
        const provinces: any[] = []
        for (const key in SG_AREA) {
            provinces.push({
                name: SG_AREA[key].name,
                code: key
            })
        }
        return provinces
    },
    getCity(provinceId = 0) {
        const cities: any[] = []
        const province = SG_AREA[provinceId]
        if (province) {
            for (const key in province.city) {
                cities.push({
                    name: province.city[key].name,
                    code: key
                })
            }
        }
        return cities
    },
    getDistrict(provinceId = 0, cityId = 0) {
        const districts: any[] = []
        if (!!provinceId && !!cityId) {
            const city = SG_AREA[provinceId].city[cityId].areas
            for (const key in city) {
                districts.push({
                    name: city[key].name,
                    code: key
                })
            }
        }
        return districts
    },
    getProvinceName(provinceCode: string) {
        return SG_AREA[provinceCode] && SG_AREA[provinceCode].name
    },
    getCityName(provinceCode: string, cityCode: string) {
        return SG_AREA[provinceCode] && SG_AREA[provinceCode].city[cityCode] && SG_AREA[provinceCode].city[cityCode].name
    },
    getDistrictName(provinceCode: string, cityCode: string, districtCode: string) {
        return SG_AREA[provinceCode] && SG_AREA[provinceCode].city[cityCode] && SG_AREA[provinceCode].city[cityCode].areas[districtCode] && SG_AREA[provinceCode].city[cityCode].areas[districtCode].name
    },
    // 根据code获取省市区
    initProviceAndCity(pCode?: string, cCode?: string, dCode?: string) {
        const arr: string[] = []
        if (!pCode) { return arr }
        arr.push(this.getProvinceName(pCode))
        if (!cCode) { return arr }
        arr.push(this.getCityName(pCode, cCode))
        if (!dCode) { return arr }
        arr.push(this.getDistrictName(pCode, cCode, dCode))
        return arr
    },
    // 根据省市区名称获取code
    initProviceAndCityCode(province: string, city: string, district: string) {
        const result = {
            province_code: '0',
            city_code: '0',
            district_code: '0'
        }
        for (const key in SG_AREA) {
            const provinceObj = SG_AREA[key]
            if (provinceObj.name === province) {
                result.province_code = key
                if (provinceObj.city) {
                    const cityListObj = provinceObj.city
                    for (const ckey in cityListObj) {
                        const cityObj = cityListObj[ckey]
                        if (cityObj.name === city) {
                            result.city_code = ckey
                            if (cityObj.areas) {
                                for (const dkey in cityObj.areas) {
                                    const districtObj = cityObj.areas[dkey]
                                    if (districtObj.name === district) {
                                        result.district_code = dkey
                                        return result
                                    }
                                }
                            }
                        }
                    }
                }
            }
        }
        return false
    }
}
export default addressSelectObj
